var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"py-3 px-12 text-center font-normal text-sm tracking-relaxed cursor-pointer select-none uppercase transition-colors rounded-full",class:_vm.reverse ? 'text-black bg-white hover:bg-blue-600 hover:text-white' : 'text-white bg-blue-600 hover:bg-blue-500',attrs:{"type":"button"},on:{"click":_vm.scrollTo}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }